import { Link } from "react-router-dom";
import SectionTitle from "@/components/feature/SectionTitle";
import ArticleCard from "@/components/feature/ArticleCard";
import { articles } from "@/mocks/articles";

export default function HotRanking() {
  const top5 = [...articles].sort((a, b) => b.hot - a.hot).slice(0, 5);

  return (
    <section className="w-full px-4 py-14 md:px-8 md:py-20">
      <SectionTitle
        eyebrow="吃瓜热度榜"
        title="热度前五，先看这几条就够了"
        desc="分值综合讨论量、阅读完成率与近 24 小时涨幅，只表示『最近有多热』。"
      />

      <div className="mt-8 grid grid-cols-1 gap-6 lg:grid-cols-[1.5fr_1fr]">
        <div className="rounded-card border border-background-200 bg-background-50 px-5 py-2 md:px-6">
          {top5.map((a, i) => (
            <ArticleCard key={a.id} article={a} layout="row" rank={i + 1} />
          ))}
        </div>

        <aside className="flex flex-col gap-5">
          <div className="rounded-card border border-background-200 bg-secondary-50 p-5 md:p-6">
            <h3 className="font-heading text-base font-semibold text-foreground-950">榜单怎么排的</h3>
            <ul className="mt-4 space-y-3 text-sm text-foreground-700">
              <li className="flex gap-2.5">
                <i className="ri-bar-chart-grouped-line mt-0.5 text-primary-600" />
                <span>讨论量：话题在公开平台的当日提及次数。</span>
              </li>
              <li className="flex gap-2.5">
                <i className="ri-book-read-line mt-0.5 text-primary-600" />
                <span>完成率：读完速览全部段落的比例。</span>
              </li>
              <li className="flex gap-2.5">
                <i className="ri-line-chart-line mt-0.5 text-primary-600" />
                <span>涨幅：相比前 24 小时的热度变化幅度。</span>
              </li>
            </ul>
          </div>

          <div className="rounded-card border border-primary-200 bg-primary-50 p-5 md:p-6">
            <span className="flex h-9 w-9 items-center justify-center rounded-md bg-primary-500 text-background-50">
              <i className="ri-lightbulb-flash-line text-lg" />
            </span>
            <h3 className="mt-3 font-heading text-base font-semibold text-foreground-950">秒开阅读建议</h3>
            <p className="mt-2 text-sm leading-relaxed text-foreground-700">
              时间紧的话，只看每篇的摘要与「结论要点」两段，平均 90 秒就能掌握一场话题的重点。
            </p>
            <Link
              to="/hot"
              className="mt-4 inline-flex items-center gap-1.5 whitespace-nowrap rounded-md bg-primary-500 px-4 py-2 text-sm font-label text-background-50 transition-colors hover:bg-primary-600 cursor-pointer"
            >
              打开完整热榜
              <i className="ri-arrow-right-line" />
            </Link>
          </div>
        </aside>
      </div>
    </section>
  );
}